export const managerMisc = {
  // Shared field / label strings reused across the advisor and user views
  fields: {
    name: "الاسم",
    lastname: "اسم العائلة",
    email: "البريد الإلكتروني",
    idNumber: "رقم الهوية",
    phone: "الهاتف",
  },
  // src/views/Manager/pagos/index.vue
  pagos: {
    title: "فواتير الدفع",
    subtitle: "قائمة المدفوعات التي أجراها المستخدمون",
    emailUser: "بريد المستخدم",
    value: "المبلغ",
    issueDate: "تاريخ الإصدار",
    status: "الحالة",
    downloadInvoice: "تنزيل الفاتورة",
    generatingInvoice: "جارٍ إنشاء الفاتورة ...",
    almostDone: "أوشك الانتهاء، يرجى الانتظار ...",
    loading: "جارٍ التحميل ...",
    invoiceError: "عذرًا، تعذّر إنشاء الفاتورة",
  },
  // src/views/Manager/advisors/* and src/components/manager/advisors/*
  advisors: {
    title: "مستشارو المنصة",
    subtitle: "قائمة المستشارين.",
    createNew: "إنشاء جديد",
    thId: "المعرّف",
    thRefCode: "الرمز المرجعي",
    thEmail: "البريد الإلكتروني",
    thRegisterDate: "تاريخ التسجيل",
    deleteConfirmMsg: "هل أنت متأكد من حذف المستشار؟",
    deleteConfirmHeader: "تأكيد",
    menuUpdateInfo: "تحديث المعلومات",
    menuAffiliatesList: "قائمة المنتسبين",
    menuDelete: "حذف",
    createTitle: "إنشاء مستشار جديد",
    savingInfo: "جارٍ حفظ المعلومات...",
    saveAdvisor: "حفظ المستشار",
    updateTitle: "تحديث بيانات المستشار",
    updatingInfo: "جارٍ تحديث المعلومات...",
    updateAdvisor: "تحديث المستشار",
    cancel: "إلغاء",
  },
  // src/components/manager/advisors/modalListAffiliates.vue
  affiliates: {
    listTitle: "قائمة المنتسبين",
    emptyPre: "لا يوجد مستخدمون منتسبون إلى الرمز",
  },
  // src/components/manager/users/menuRoutes.vue
  menu: {
    checkinsDone: "عمليات تسجيل الوصول المكتملة",
    checkinsPending: "عمليات تسجيل الوصول المعلّقة",
    checkinsScheduled: "عمليات تسجيل الوصول المجدولة",
    logoAndName: "شعار واسم مكان الإقامة",
    welcomeMessage: "رسالة الترحيب",
    policies: "سياسات مكان الإقامة",
    roomKeys: "مفاتيح الغرف",
    authorities: "السلطات",
    guestReviews: "تقييمات النزلاء",
  },
  // src/components/manager/users/accommodations.vue
  accommodations: {
    createdDate: "تاريخ الإنشاء",
    checkins: "عمليات تسجيل الوصول",
  },
  // src/views/Manager/index.vue
  dashboard: {
    title: "لوحة الإدارة",
    subtitle: "قائمة إحصاءات المنصة",
    registeredUsers: "المستخدمون المسجّلون",
    viewList: "عرض القائمة",
    propertiesCreated: "العقارات المُنشأة",
    checkinsDone: "عمليات تسجيل الوصول المكتملة",
  },
};
